import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu/ActionMenu';
import { MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Overflow } from 'ui/icons/navigation/Overflow';
import { Body2 } from 'ui/theme/typography/components';

const Wrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 2.5px 15px;
  &:first-child {
    padding-top: 5px;
  }
  &:last-child {
    padding-bottom: 5px;
  }
`;

const Name = styled(Body2)`
  margin: 0;
`;

type ListBodyLabelRowProps = {
  label: any;
  actionMenuOptions: any[];
};

export const ListBodyLabelRow = ({ label, actionMenuOptions }: ListBodyLabelRowProps) => {
  return (
    <Wrapper role="listitem" aria-labelledby={label.name}>
      <div>
        <Name id={label.name}>{label.name || ''}</Name>
      </div>
      <ActionMenu id="overflow-menu" align={MENU_ALIGNMENTS.RIGHT} options={actionMenuOptions}>
        <IconButton size={BUTTON_SIZES.SMALL} variant={BUTTON_VARIANTS.GHOST}>
          <Overflow />
        </IconButton>
      </ActionMenu>
    </Wrapper>
  );
};
